import Box from './Box';
import './TextInput.css';
import Text from './Text';
import classnames from 'classnames';
import React, { useState } from 'react';

export interface TextInputProps {
  type?: string;
  value?: string | number | string[];
  onChange?(e: any): void;
  onValueChange?(value: any): void;
  onFocus?(e: any): void;
  onBlur?(e: any): void;
  onKeyDown?(e: any): void;
  forceV2?: boolean;
  end?: string;
  step?: string;
  ref?: React.LegacyRef<HTMLInputElement>;
  focus?: boolean;
  placeholder?: string;
  grey?: boolean;
}

export default function TextInput({
  value = '',
  onFocus,
  onBlur,
  onKeyDown,
  onValueChange,
  type = 'text',
  end,
  step,
  grey,
  placeholder
}: TextInputProps) {
  const [focused, setFocused] = useState(false);

  const textInputClass = classnames(
    'TextInput',
    grey && 'TextInput--grey',
    { 'TextInput--focused': focused, }
  );

  return (
    <Box
      className={textInputClass}
      alignItems='center'
    >
      <input
        placeholder={placeholder}
        type={type}
        step={step}
        autoComplete='nope'
        className='TextInput-input'
        value={value}
        onChange={(e) => {
          onValueChange && onValueChange(e.target.value);
        }}
        onKeyDown={onKeyDown}
        onFocus={(e) => {
          setFocused(true);
          onFocus && onFocus(e);
        }}
        onBlur={(e) => {
          setFocused(false)
          onBlur && onBlur(e);
        }}
      />
      {
        end &&
        <button>
          <Box
            alignItems='center'
            paddingRight={8}
            paddingVertical={4}
            className='TextInput-end'
          >
            <div style={{
              lineHeight: 0,
              flex: '1 1 auto'
            }}>
              <Text>{end}</Text>
            </div>
          </Box>
        </button>
      }
    </Box>
  );
}
